
import { useState } from "react";
import { motion } from "framer-motion";
import { FaCog, FaWindows } from "react-icons/fa";

const HomePage2 = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showWH40kModal, setShowWH40kModal] = useState(false);

  const options = [
    {
      id: 1,
      title: "Blood Bowl League",
      image: "AOS_logo_transp.png",
      description: "Blood Bowl League",
      details: "Blood Bowl League",
      link: null,
    },
    {
      id: 2,
      title: "WH40k League",
      image: "WH40k_logo_transp.png",
      description: "WH40k League",
      details: "WH40k league",
      link: null,
    },
  ];

  const handleOptionSelect = (option) => {
    if (option.title === "WH40k League") {
      setShowWH40kModal(true);
    } else if (option.link) {
      window.location.href = option.link;
    } else {
      setSelectedOption(option.id);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white relative">
      <div className="absolute top-4 right-4">
        <button onClick={() => setShowModal(true)}>
          <FaCog size={30} className="text-white hover:text-gray-300" />
        </button>
      </div>

      <div className="w-full">
        <center>
          <img
            src="COBRADOR_LEAGUE_LOGO_02_FINAL.png"
            alt="El Cobrador League Banner"
            className="w-100 h-80 object-cover"
          />
        </center>
      </div>

      <div className="flex-1 p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-center text-white mb-12">
            Selecciona tu liga
          </h1>
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
            {options.map((option) => (
              <motion.div
                key={option.id}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="w-full md:w-1/2"
              >
                <button
                  onClick={() => handleOptionSelect(option)}
                  className="focus:outline-none w-full h-full"
                >
                  <div className="relative overflow-hidden rounded-2xl shadow-xl transition-all duration-300 hover:shadow-2xl w-full h-[225px]">
                    <img
                      src={option.image}
                      alt={option.title}
                      className="w-full h-full object-contain bg-gray-800"
                      onError={(e) => {
                        e.target.src = "https://images.unsplash.com/photo-1560472355-536de3962603";
                      }}
                    />
                  </div>
                </button>
              </motion.div>
            ))}
          </div>
          {selectedOption && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="mt-8 p-6 bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg text-white max-w-2xl mx-auto"
            >
              <h3 className="text-2xl font-semibold mb-4">
                {options.find((opt) => opt.id === selectedOption)?.title}
              </h3>
              <p className="text-lg">
                {options.find((opt) => opt.id === selectedOption)?.details}
              </p>
            </motion.div>
          )}
        </div>
      </div>

      {showWH40kModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-white w-80">
            <div className="flex flex-col gap-4">
              <button
                className="bg-purple-700 hover:bg-purple-800 py-2 px-4 rounded"
                onClick={() => {
                  window.location.href = "/wh40k?idleague=1";
                }}
              >
                El Cobrador League 24/25
              </button>
              <button
                className="bg-indigo-700 hover:bg-indigo-800 py-2 px-4 rounded"
                onClick={() => {
                  //window.location.href = "/Leaderboardv2";
                  window.location.href = "/wh40k?idleague=2"
                }}
              >
                El Velo de Sangre: Crónicas del Subsector Vortem
              </button>
              <button
                className="text-sm text-gray-400 hover:text-white mt-2"
                onClick={() => setShowWH40kModal(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage2;
